import { TopicData } from '@ysura/common';
import { intersectionBy } from 'lodash';

export const intersectionTopics = (
  topics1: Array<TopicData>,
  topics2: Array<TopicData>
): Array<TopicData> => {
  return intersectionBy(topics1, topics2, 'oid');
};
